import React from 'react'
import './footer.css'
import {BsFacebook} from 'react-icons/bs'
import {BsInstagram} from 'react-icons/bs'
import {IoLogoTwitter} from 'react-icons/io'

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>Kshitij Jaiswal</a>
      <ul className='links'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className='footer__socials'>
        <a href="https://www.facebook.com/kshitij.jaiswal.140/" target="_blank"><BsFacebook/></a>
        <a href="https://www.instagram.com/kshitij_jais/" target="_blank"><BsInstagram/></a>
        <a href="https://twitter.com/harshjais4" target="_blank"><IoLogoTwitter/></a>
      </div>
    </footer>
  )
}

export default Footer